import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";

import CampaignAnalytics from "./campaign/index";
import LeadsAnalytics from "./leads/index";

const Analytics = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      {/* Tabs Header */}
      <Tabs
        value={activeTab}
        onChange={handleChange}
        sx={{
          borderBottom: "1px solid #E0E0E5",
          mb: 2,
        }}
      >
        <Tab label="Campaigns" />
        <Tab label="Leads" />
      </Tabs>

      {/* Tab Content */}
      <Box sx={{ mt: 2 }}>
        {activeTab === 0 && <CampaignAnalytics />}
        {activeTab === 1 && <LeadsAnalytics />}
      </Box>
    </Box>
  );
};

export default Analytics;
